import { motion } from "framer-motion"
import { bufetesBenefits, usuariosBenefits } from "@/services/start/getBenefits"

const benefitVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
}

const BenefitCard = ({ title, benefits, initialX }) => (
  <motion.div
    className="bg-white rounded-lg shadow-xl p-8 w-full overflow-hidden"
    initial={{ opacity: 0, x: initialX }}
    whileInView={{ opacity: 1, x: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.6 }}
  >
    <motion.h3
      className="text-2xl font-semibold mb-8 text-[var(--gold)]"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      {title}
    </motion.h3>
    <div className="space-y-8">
      {benefits.map((benefit, index) => (
        <motion.div
          key={index}
          className="flex items-start"
          variants={benefitVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className="text-3xl text-[var(--gold-dark)] mr-4">{benefit.icon}</div>
          <div>
            <h4 className="text-xl font-semibold mb-2">{benefit.title}</h4>
            <p className="text-gray-600">{benefit.description}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </motion.div>
)

const Benefits = () => {
  return (
    <section className="py-20 overflow-hidden">
      <div className="max-w-screen-lg mx-auto px-4">
        <motion.h2
          className="text-4xl font-bold text-center mb-16 text-gray-800"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Beneficios para Bufetes y Usuarios
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8 overflow-hidden">
          <BenefitCard title="Para Bufetes" benefits={bufetesBenefits} initialX={-50} />
          <BenefitCard title="Para Usuarios" benefits={usuariosBenefits} initialX={50} />
        </div>
      </div>
    </section>
  )
}

export default Benefits
